<template>
    <div class="animated fadeIn">
        <div class="card admin">
            <div class="card-header">
                Статистика звонков
                <div class="pull-right" style="margin-top: 7px">
                    <button class="btn btn-secondary" :class="{ active: showFilter }" data-toggle="dropdown" href="#" @click.prevent="showFilter = !showFilter">
                        <i class="fa fa-filter"></i> Фильтр
                    </button>
                </div>
                <div v-if="showFilter" class="row mt-1">
                    <div class="col-6">
                        <form сlass="form-horizontal">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Номер телефона</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control" v-model="params.query">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Город</label>
                                <div class="col-md-5">
                                    <multiselect
                                            :options="cities"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Город не выбран"
                                            track-by="id" label="name"
                                            @input="changeCity"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Номер на который позвонили</label>
                                <div class="col-md-5">
                                    <multiselect
                                            :options="virtualNumbers"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Номер не выбран"
                                            track-by="id" label="name"
                                            @input="changeVirtualNumber"
                                            @open="loadVirtualNumbers"
                                            :loading="loadingVirtualNumbers"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Внутренний номер, который ответил</label>
                                <div class="col-md-5">
                                    <multiselect
                                            :options="internalNumbers"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Номер не выбран"
                                            track-by="id" label="number"
                                            @input="changeInternalNumber"
                                            @open="loadInternalNumbers"
                                            :loading="loadingInternalNumbers"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-6">
                        <form сlass="form-horizontal">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Интервал с</label>
                                <div class="col-md-5">
                                    <input type="datetime-local" class="form-control" v-model="params.dateTimeFrom">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">Интервал по</label>
                                <div class="col-md-5">
                                    <input type="datetime-local" class="form-control" v-model="params.dateTimeTo">
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="card-block admin__list">
                <div class="row mb-1 text-muted small">
                    <div class="col-6 col-md-3 col-lg-2">Дата и время</div>
                    <div class="col-6 col-md-3 col-lg-1">Номер звонившего</div>
                    <div class="col-6 col-md-4 col-lg-1">Номер на который звонили</div>
                    <div class="col-6 col-md-2 col-lg-1">Город</div>
                    <div class="col-6 col-md-3 col-lg-2">Сайт</div>
                    <div class="col-6 col-md-7 col-lg-2">Кто ответил</div>
                    <div class="col-6 col-md-2 col-lg-2">Запись разговора</div>
                </div>
                <loading v-if="loading" message="Загружаем звонки..."></loading>
                <div v-else class="row mb-1 admin__list__item admin__list__item_hover-bg-gray" v-for="(item, index) in items">
                    <div class="col-6 col-md-3 col-lg-2">{{item.date}} {{item.time}}</div>
                    <div class="col-6 col-md-3 col-lg-1">{{item.number}}</div>
                    <div class="col-6 col-md-4 col-lg-1"><span v-if="item.virtualNumber">{{item.virtualNumber.number}}</span></div>
                    <div class="col-6 col-md-2 col-lg-1">
                        <span v-if="item.virtualNumber && item.virtualNumber.city">
                            {{item.virtualNumber.city.name}}
                        </span>
                    </div>
                    <div class="col-6 col-md-3 col-lg-2">
                        <span v-if="item.virtualNumber">
                            {{item.virtualNumber.site}}
                        </span>
                    </div>
                    <div class="col-6 col-md-7 col-lg-2">
                        <template v-if="item.internalNumber">
                            Внутренний номер: {{item.internalNumber.number}}<br>
                             <span class="badge badge-info" v-for="(user, index) in item.internalNumber.users">
                                <router-link :to="{ name: 'ViewProfile', params: { id: user.id }}">{{user.fullname}}</router-link>
                             </span>
                        </template>
                    </div>
                    <div class="col-12 col-md-2 text-center text-md-left">
                        <template v-if="item.records">
                            <audio v-for="record in item.records" ref="player" controls>
                                <source :src="record.url">
                                Ваш браузер не поддрживает воспроизведение аудио записей
                            </audio>
                        </template>
                        <loading v-else-if="loadingRecords === item.pbxCallId" :size="2" message="Загружаем записи..."></loading>
                        <b-button v-else size="sm" variant="secondary" @click.prevent="loadRecords(item.pbxCallId, index)">Загрузить</b-button>
                    </div>
                </div>
            </div>
            <div class="card-header">
                <b-pagination class="mb-0" size="md" :total-rows="itemsPage.paginator.total_count" v-model="params.page" :per-page="itemsPage.paginator.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import getCallsQuery from './../../../gql/queries/PBX/getIncomingCalls.graphql'
  import getVirtualNumbers from './../../../gql/queries/PBX/getVirtualNumbers.graphql'
  import getInternalNumbers from './../../../gql/queries/PBX/getInternalNumbers.graphql'
  import getAudioRecordsQuery from './../../../gql/queries/PBX/getAudioRecords.graphql'
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      items () {
        this.incomingCallsCache = JSON.parse(JSON.stringify(this.itemsPage.incomingCalls))
        return this.incomingCallsCache
      },
      ...mapState({
        cities: state => state.globalStore.cities
      })
    },
    data () {
      return {
        params: {
          page: 1,
          cityId: null,
          virtualNumberId: null,
          internalNumberId: null,
          dateTimeFrom: null,
          dateTimeTo: null,
          query: null
        },
        itemsPage: {
          incomingCalls: null,
          paginator: {
            total_count: 10
          }
        },
        incomingCallsCache: [],
        blockLoading: false,
        showFilter: false,
        loading: false,
        loadingRecords: false,
        virtualNumbers: [],
        loadingVirtualNumbers: false,
        internalNumbers: [],
        loadingInternalNumbers: false
      }
    },
    name: 'incomingCalls',
    components: {
      Multiselect
    },
    methods: {
      loadRecords (pbxCallId, index) {
        this.loadingRecords = pbxCallId
        this.$apollo.query({
          query: getAudioRecordsQuery,
          variables: {
            pbxCallId
          }
        }).then(result => {
          this.incomingCallsCache[index].records = result.data.audioRecords
          this.loadingRecords = false
        }).catch(error => {
          console.log(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loadingRecords = false
        })
      },
      changeCity (city) {
        if (city) {
          this.params.cityId = city.id
        } else {
          this.params.cityId = null
        }
      },
      changeVirtualNumber (number) {
        if (number) {
          this.params.virtualNumberId = number.id
        } else {
          this.params.virtualNumberId = null
        }
      },
      changeInternalNumber (number) {
        if (number) {
          this.params.internalNumberId = number.id
        } else {
          this.params.internalNumberId = null
        }
      },
      loadVirtualNumbers () {
        this.loadingVirtualNumbers = true
        this.$apollo.query({
          query: getVirtualNumbers,
          variables: {
            all: true
          }
        }).then(result => {
          this.virtualNumbers = result.data.virtualNumbers
          this.loadingVirtualNumbers = false
        }).catch(error => {
          console.log(error)
          this.loadingVirtualNumbers = false
        })
      },
      loadInternalNumbers () {
        this.loadingInternalNumbers = true
        this.$apollo.query({
          query: getInternalNumbers,
          variables: {
            all: true
          }
        }).then(result => {
          this.internalNumbers = result.data.internalNumbers
          this.loadingInternalNumbers = false
        }).catch(error => {
          console.log(error)
          this.loadingInternalNumbers = false
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      itemsPage: {
        query: getCallsQuery,
        variables () {
          return {
            page: this.params.page,
            cityId: this.params.cityId,
            virtualNumberId: this.params.virtualNumberId,
            internalNumberId: this.params.internalNumberId,
            dateTimeFrom: this.params.dateTimeFrom,
            dateTimeTo: this.params.dateTimeTo,
            query: this.params.query
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IncomingCalls.vue?67c08050